import React from "react";

function RepostFilledIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="56"
      height="56"
      viewBox="0 0 56 56"
    >
      <g
        id="Group_27857"
        data-name="Group 27857"
        transform="translate(14596 14746)"
      >
        <g
          id="Rectangle_1959"
          data-name="Rectangle 1959"
          transform="translate(-14596 -14746)"
          fill="#fff"
          stroke="#596970"
          strokeWidth="1"
        >
          <rect width="56" height="56" rx="28" stroke="none" />
          <rect x="0.5" y="0.5" width="55" height="55" rx="27.5" fill="none" />
        </g>
        <g
          id="Group_27856"
          data-name="Group 27856"
          transform="translate(-63 1)"
        >
          <rect
            id="Rectangle_11971"
            data-name="Rectangle 11971"
            width="35"
            height="33"
            transform="translate(-14522 -14735)"
            fill="#596970"
            opacity="0"
          />
          <path
            id="Path_18883"
            data-name="Path 18883"
            d="M21.194,3.287,11.32,13.161l.01,5.617,5.6-.01L26.8,8.9V25.769a1.322,1.322,0,0,1-1.322,1.322H4.322A1.322,1.322,0,0,1,3,25.769V4.609A1.322,1.322,0,0,1,4.322,3.287Zm4.93-1.19,1.87,1.87L15.838,16.124l-1.867,0,0-1.873Z"
            transform="translate(-14520 -14733.098)"
            fill="#596970"
            opacity="0.9"
          />
        </g>
      </g>
    </svg>
  );
}

export default RepostFilledIcon;
